import React, { forwardRef } from "react";
import { cx } from "../../utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & { hasError?: boolean };
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { hasError, className, ...props }, ref,
) {
  return <input ref={ref} aria-invalid={hasError || undefined} className={cx(
    "w-full rounded-lg border-2 bg-input px-3 py-2.5 text-input-foreground text-form-input outline-none disabled:opacity-45",
    hasError ? "border-danger-border focus:border-danger" : "border-control focus:border-control", className,
  )} {...props} />;
});

export function FormField({ label, id, error, children }: {
  label: string; id: string; error?: string; children: React.ReactNode;
}) {
  return <div className="flex flex-col gap-1.5">
    <label htmlFor={id} className="text-label text-control">{label}</label>
    {children}
    {error && <p id={`${id}-error`} className="m-0 text-error text-danger" role="alert">{error}</p>}
  </div>;
}
